var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view',{attrs:{"keep-alive":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }